import React, { ButtonHTMLAttributes } from 'react';

import UtilFunctions from '~utils/functions';

import CustomClipLoader from '../CustomClipLoader';

import * as ButtonStyles from './_actionButton.module.scss';

type TActionButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    label: string;
    className?: string;
    isLoading?: boolean;
    testId?: string;
}

const ActionButton = (props: TActionButtonProps) => {
    const {
        label,
        className,
        isLoading,
        testId,
        ...otherProps
    } = props;

    const styles = UtilFunctions.Styles.concatClassNames([
        ButtonStyles.container,
        className,
    ]);

    return (
        <button
            className={styles}
            {...otherProps}
            data-testid={testId}
        >
            {isLoading
                ? <CustomClipLoader />
                : (
                    <p>
                        {label}
                    </p>
                )
            }
        </button>
    );
};

export default ActionButton;
